import Service from '../Service'
import {http} from '../config'

export default class RecebivelService extends Service{

    constructor(){
        super('recebivel');
    }

    Baixar(modelo){
        return http.put(`${this._nomeControle}/${modelo.id}/baixar`, modelo);
    }

    Cancelar(id){
        return http.put(`${this._nomeControle}/${id}/cancelar`);
    }

    Reabrir(id){
        return http.put(`${this._nomeControle}/${id}/reabrir`);
    }

    Gerar(modelo){
        return http.post(`${this._nomeControle}/gerar`, null, { 
            params: {
                mesAnoInicial: modelo.mesAnoInicial,
                mesAnoFinal: modelo.mesAnoFinal,
                bancoId: modelo.bancoId,
                regiaoId: modelo.regiaoId
            }
        });
    }

    VerificaRetorno(bancoId, pagamentos){
        return http.post(`${this._nomeControle}/verificaretorno`, pagamentos, { 
            params: {
                bancoId: bancoId
            }
        });
    }

    BaixarRetorno(bancoId, pagamentos){
        return http.post(`${this._nomeControle}/baixarretorno`, pagamentos, { 
            params: {
                bancoId: bancoId
            }
        });
    }

    GerarBoleto(modelo){
        return http.post(`${this._nomeControle}/gerarboleto`, null, { 
            params: {
                bancoId: modelo.bancoId,
                recebivelId: modelo.recebivelId
            }
        });
    }

    EnviarBoleto(mesAnoInicial, mesAnoFinal, periodo){
        return http.post(`${this._nomeControle}/enviarBoleto`, null, {
            params:{
                mesAnoInicial,
                mesAnoFinal,
                periodo
            }
        })
    }

    BaixarBoleto(detalhar, bancoId){
        return http.post(`${this._nomeControle}/baixarRetorno`, detalhar, {
            params:{
                bancoId
            }
        })
    }

    AtualizaRemessa(recebiveis){
        return http.post(`${this._nomeControle}/atualizaremessa`, recebiveis);
    }

    AcompanhamentoDoacao(filtro){
        return http.get(`${this._nomeControle}/acompanhamentodoacao`, {
            params: {
                doadorId: filtro.doadorId,
                regiaoId: filtro.regiaoId,
                inibirDoadoresSemRecebiveis: filtro.doadoresInativos,            
                ano: filtro.ano,
            }
        });
    }

    BoletoPdf(Ids){
        return http.get(`${this._nomeControle}/Boleto/Pdf`, {
            params: {
                Ids
            },
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf',
                'Access-Control-Allow-Origin': '*'
            }
        });
    }

    BoletoHtml(Ids){
        return http.get(`${this._nomeControle}/Boleto/Html`, {
            params: {
                Ids
            }
        });
    }

    BoletoHtmlDoador(id, empresaId){
        return http.get(`${this._nomeControle}/boleto/html/doador`, {
            params: {
                id,
                empresaId
            }
        });
    }

    GetFiltro(parametros, filter){
        if(parametros === '?'){
            parametros = '';
        }

        if (filter) {
            let paramTemp = '';

            if (filter.documentoId){
                paramTemp += `id eq ${filter.documentoId}`;
            }

            if (filter.bancoId){
                paramTemp += `bancoId eq ${filter.bancoId}`;
            }

            if (filter.formaPagamentoId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `formaPagamento eq ${filter.formaPagamentoId}`;
            }

            if (filter.doadorId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `doadorId eq ${filter.doadorId}`;
            }

            if (filter.projetoId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `projetoId eq ${filter.projetoId}`;
            }

            if (filter.regiaoId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `doador/regiaoId eq ${filter.regiaoId}`;
            }

            if (filter.pessoalId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `doador/pessoalId eq ${filter.pessoalId}`;
            }

            if (filter.emissaoNota){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `doador/emissaoNota eq OngFacil.Domain.Geral.EnumResp_Basica'${filter.emissaoNota}'`;
                paramTemp += ` and nfseId eq null`;
            }

            if (filter.situacao){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `situacao eq '${filter.situacao}'`;
            }

            if (filter.vencimentoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataVencimento ge ${filter.vencimentoInicial}`;
            }
            
            if (filter.vencimentoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataVencimento le ${filter.vencimentoFinal}`;
            }

            if (filter.pagamentoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataPagamento ge ${filter.pagamentoInicial}`;
            }
            
            if (filter.pagamentoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataPagamento le ${filter.pagamentoFinal}`;
            }

            if (filter.emissaoInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao ge ${filter.emissaoInicial}`;
            }
            
            if (filter.emissaoFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataEmissao le ${filter.emissaoFinal}`;
            }

            if (filter.competenciaInicial){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataCompetencia ge ${filter.competenciaInicial}`;
            }
            
            if (filter.competenciaFinal){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `dataCompetencia le ${filter.competenciaFinal}`;
            }

            if (filter.recibo){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `doador/emissaoRecibo eq '${filter.recibo}'`;
            }

            if (filter.codigoInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id ge ${filter.codigoInicio}`;
            }

            if (filter.codigoFim){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id le ${filter.codigoFim}`;
            }

            if (paramTemp) {
                if(parametros){
                    parametros += '&';
                }
                else{
                    parametros += '?';
                }
                parametros += `$filter=${paramTemp}`;
            }
        }

        return parametros;
    }
    
    ListarComFiltro(page, pageSize, sortBy, desc, search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns);
        parametros = this.GetFiltro(parametros, filter);
        return http.get(`${this._nomeControle}${parametros}`, this.GetHeader(include));
    }

    TotalizadoresComFiltro(search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);
        parametros = this.GetFiltro(parametros, filter);

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, this.GetHeader(include));
    }

    Relatorio(doadorId, projetoId, vencimentoInicial, vencimentoFinal, pagamentoInicial, pagamentoFinal, emissaoInicial, emissaoFinal, competenciaInicial, competenciaFinal, 
        formaPagamentoId, bancoId, pessoaId, regiaoId, stuacaoId, codigoInicial, codigoFinal){
        return http.get(`${this._nomeControle}/Relatorio`,{
            params:{
                doadorId,
                projetoId,
                vencimentoInicial,
                vencimentoFinal,
                pagamentoInicial,
                pagamentoFinal,
                emissaoInicial,
                emissaoFinal,
                competenciaInicial,
                competenciaFinal,
                formaPagamentoId,
                bancoId,
                pessoaId,
                regiaoId,
                stuacaoId,
                codigoInicial,
                codigoFinal
            }
        });
    }

  }
